module.exports = window["underscore"];